import { render, staticRenderFns } from "./tableContent.vue?vue&type=template&id=272472e9&"
import script from "./tableContent.vue?vue&type=script&lang=js&"
export * from "./tableContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports